import React from 'react';
import { NumberFormatter } from '../../../../shared/ui/number-formatter';
import { Can } from '@shared/lib/ability';
import { useAppSelector } from '../../../../app/store/store';
import { getCurrencySymbol } from '@shared/lib/currency';

interface CartTotalProps {
  cartItems: any[];
  setCartSteps: (step: string) => void;
  total: number;
}

export function CartTotal({ cartItems, setCartSteps, total }: CartTotalProps) {
  const currency = useAppSelector((state) => state.cart.currency);
  const currencySymbol = getCurrencySymbol(currency);
  const totalItemQuantity = cartItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );
  const totalVerificationQuantity = cartItems.reduce(
    (sum, item) => sum + (item?.verification_quantity || 0),
    0
  );
  const totalPassportQuantity = cartItems.reduce(
    (sum, item) => sum + (item?.passport_quantity || 0),
    0
  );
  const totalItemsPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const totalVerificationPrice = cartItems.reduce(
    (sum, item) => sum + (item.verificationTotalPrice || 0),
    0
  );
  const totalPassportPrice = cartItems.reduce(
    (sum, item) => sum + (item.passportTotalPrice || 0),
    0
  );

  const summaryItems = [
    {
      label: 'Кол-во товаров в корзине',
      value: totalItemQuantity,
      isCount: true,
      isPrice: false,
    },
    {
      label: 'Кол-во поверок в корзине',
      value: totalVerificationQuantity,
      isCount: true,
      isPrice: false,
    },
    {
      label: 'Кол-во паспортов в корзине',
      value: totalPassportQuantity,
      isCount: true,
      isPrice: false,
    },
    {
      label: `Сумма товаров (${cartItems.length})`,
      value: totalItemsPrice,
      isCount: false,
      isPrice: true,
    },
    {
      label: 'Сумма поверок',
      value: totalVerificationPrice,
      isCount: false,
      isPrice: false,
    },
    {
      label: 'Сумма паспортов',
      value: totalPassportPrice,
      isCount: false,
      isPrice: false,
    },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm sticky top-4">
      <div className="space-y-4">
        {summaryItems.map((item, index) => (
          <div
            key={index}
            className="flex justify-between items-center relative pb-2"
          >
            <span className={`text-sm text-gray-600 ${item.isPrice ? 'text-base font-bold' : 'text-sm font-medium'} bg-white pr-2 relative z-10`}>
              {item.label}:
            </span>
            <span className={`text-sm font-medium text-gray-900 ${item.isPrice ? 'text-lg font-bold' : 'text-sm font-medium'} bg-white pl-2 relative z-10`}>
              {item.isCount ? (
                item.value
              ) : (
                <>
                  <NumberFormatter number={item.value} /> {currencySymbol}
                </>
              )}
            </span>
          </div>
        ))}

        <div className="pt-4 ">
          <div className="flex justify-between items-center">
            <span className="text-base font-semibold text-gray-900">
              Всего к оплате:
            </span>
            <span className="text-[20px] font-bold text-gray-900">
              <NumberFormatter number={total} /> {currencySymbol}
            </span>
          </div>
        </div>

        <Can I="add" a="order">
          <button
            onClick={() => setCartSteps('1')}
            className="w-full mt-4 px-6 py-3.5 bg-red-600 text-white text-base font-medium rounded-xl hover:bg-red-700 active:bg-red-800 transition-colors shadow-sm"
          >
            Оформить заказ
          </button>
        </Can>
      </div>
    </div>
  );
}
